












































































































































import {
  ApiSearchColumn,
  ColumnType,
} from "@/components/apiSearch/models/ApiSearch";
import configuration, {
  AppConfiguration,
  loadConfiguration,
} from "@/models/Configuration";
import BankStatementAccountingItem from "../models/BankStatementAccountingItem";
import eventBus from "@/services/eventBus";
import http, { checkResponse } from "@/services/http";
import dayjs from "dayjs";
import Vue from "vue";
import store, { BankStatementStore } from "../services/BankStatementStore";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import Page from "@/components/Page.vue";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import { t } from "@/plugins/i18n";

interface Computed {
  columns: ApiSearchColumn[];
  url: string;
  hasError: boolean;
}

interface Data {
  items: BankStatementAccountingItem[];
  store: BankStatementStore;
  configuration: AppConfiguration;
  showErrorList: boolean;
}

interface Method {
  setItems(items: BankStatementAccountingItem[]): void;
  getAccName(code: string): string;
  getPrecision(): number;
  getBookingDate(item: BankStatementAccountingItem): string;
  preAccount(): void;
}

export default Vue.extend<Data, Method, Computed, {}>({
  components: { ApiSearchPage, Page, MoneyDisplay },

  data() {
    return {
      store,
      configuration,
      items: [],
      showErrorList: false
    };
  },

  methods: {
    async preAccount() {
      const result = await http
        .post(`bank-statement/${Number(this.$route.params.id)}/pre-account`)
        .then(checkResponse);
      if (result) {
        await this.store.loadAccountingErrors();

        eventBus.$emit("success", t("BankStatement_SikeresKontirozas"));
        eventBus.$emit("bank-statement-accounting:reload");
      }
    },
    setItems(items: BankStatementAccountingItem[]) {
      this.items = items;
    },

    getBookingDate(item) {
      return dayjs(item.accDate) > dayjs("1990-01-01")
        ? dayjs(item.accDate).format("YYYY. MM. DD")
        : "-";
    },

    getAccName(code: string) {
      return (
        this.store.accountingCodes.find((x) => x.code == code)?.accName ?? "-"
      );
    },

    getPrecision() {
      const res = this.configuration.operel
        ? this.store.bankStatement.currency != "HUF"
          ? 2
          : 0
        : this.configuration.getCurrDigits(this.store.bankStatement.currency)
            ?.geniHeadDigits ?? 2;
      return res;
    },
  },

  async mounted() {
    if (this.store.bankStatement.id < 1) {
      await this.store.loadBankStatement(Number(this.$route.params.id));
    }

    await this.store.loadAccountingCodes(Number(this.$route.params.id));
    await this.store.loadAccountingErrors();
    await this.store.loadBankStatementSummary();

    if (!this.configuration.isLoaded) {
      await loadConfiguration();
    }
  },

  computed: {
    hasError(){
      return this.store.accountingErrors.length > 0;
    },

    url() {
      return `bank-statement/${Number(this.$route.params.id)}/account-items`;
    },

    columns: (): ApiSearchColumn[] => [
      { field: "type", title: "" },
      { field: "owe", title: t("Tartozik"), fieldClass: "oweCell" },
      {
        field: "oweAmount",
        title: t("Osszeg"),
        cell: "oweAmount",
        fieldClass: "oweCell",
        type: ColumnType.Money,
      },
      {
        field: "demands",
        title: t("Kovetel"),
        cell: "demands",
        fieldClass: "demandsCell",
      },
      {
        field: "demandedAmount",
        title: t("Osszeg"),
        cell: "demandedAmount",
        fieldClass: "demandsCell",
        type: ColumnType.Money,
      },
      {
        field: "accDate",
        title: t("KonyvelesDatuma"),
        cell: "accDate",
      },
      { field: "invCode", title: t("SzamlaPrefix") },
      { field: "invNo", title: t("Szamla"), cell: "invNo" },
    ],
  },
});
